module.exports = "/next-static/_next/static/images/block_image_everything_you_need-c0a0323c11d026060ae113a45585ab0a.webp";